/* eslint-disable node/no-unsupported-features/es-syntax */
/* eslint-disable filenames/no-index */
import { SpawnGameLauncher } from "@spawn/launcher";
// Deep import: the barrel would pull the whole core into the entry chunk.
import { addPageStyles } from "@spawn/nrg-games-core/src/utils/pageStyles";

SpawnGameLauncher.entrypoint = () => import(/* webpackChunkName: "game" */ "./main");

addPageStyles();
